import { useDebounceValue } from '@repo/hooks/useDebounceValue';
import { useState, useCallback } from 'react';

export type TabValue = 'main' | 'usersSelect' | 'groupsSelect';

export function useMeetingFormTabs() {
  const [tabs, setTabs] = useState<TabValue>('main');
  const [searchValue, setSearchValue] = useState<string>('');
  const searchDebouncedValue = useDebounceValue(searchValue, 400);

  const isMainTab = tabs === 'main';
  const isUsersSelectTab = tabs === 'usersSelect';
  const isGroupsSelectTab = tabs === 'groupsSelect';

  const goToMainTab = useCallback(() => setTabs('main'), []);
  const goToUsersTab = useCallback(() => setTabs('usersSelect'), []);
  const goToGroupsTab = useCallback(() => setTabs('groupsSelect'), []);

  return {
    tabs,
    setTabs,
    searchValue,
    setSearchValue,
    searchDebouncedValue,
    isMainTab,
    isUsersSelectTab,
    isGroupsSelectTab,
    goToMainTab,
    goToUsersTab,
    goToGroupsTab,
  };
}
